export default "__VITE_ASSET__934d0452__"